import React from 'react';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import ContentSearchBar from '@/components/organisms/content-search-bar/content-search-bar';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import Row from '@/components/utilities/row/row';
import { useI18n } from '@/libraries/contexts/i18n-context';
import styles from './main-navigation-large-dropdown-content-search.module.scss';

export interface MainNavigationLargeDropdownContentSearchProps {
  /** Indicates whether the dropdown is open */
  isOpen?: boolean;
  /** The link of the cta button */
  link: Content.Properties.Link;
  /** An event that is triggered on close */
  onClose?: () => void;
}

const MainNavigationLargeDropdownContentSearch = ({
  isOpen,
  link,
  onClose,
}: MainNavigationLargeDropdownContentSearchProps) => {
  const { t } = useI18n();

  return (
    <Container className={styles.component}>
      <Row>
        <Column className={styles.column}>
          <button
            aria-label={t('items.common.words.close')}
            className={styles.close}
            onClick={onClose}
          >
            <Icon name="Close" size={24} />
          </button>
        </Column>
      </Row>

      <Row>
        <Column>
          <div className={styles.container}>
            <Typography className={styles.headline} tagStyle="displayMedium">
              {t('items.common.words.search')}
            </Typography>

            <ContentSearchBar
              focus={isOpen}
              link={link}
              onSearch={onClose}
              shouldRedirect
            />
          </div>
        </Column>
      </Row>
    </Container>
  );
};

MainNavigationLargeDropdownContentSearch.displayName =
  'MainNavigationLargeDropdownContentSearch';

export default MainNavigationLargeDropdownContentSearch;
